import GeoJSON from 'ol/format/GeoJSON';
import WKT from 'ol/format/WKT';

const formatGeoJson = new GeoJSON();
const formatWKT = new WKT();

const removeTrailingZeros = (match, num) => {
  return String(parseFloat(num));
};

export const serializeGeometry = geometry => {
  if (!geometry) {
    return '';
  }

  const str = formatWKT.writeGeometry(formatGeoJson.readGeometry(geometry));
  // truncate to 4 decimals and encode space as +
  return str
    .replace(/(\d+.\d{6})\d+\b/g, removeTrailingZeros)
    .replace(/ /g, '+');
};

export const deserializeGeometry = str => {
  if (!str) {
    return null;
  }
  return formatGeoJson.writeGeometry(
    formatWKT.readGeometry(decodeURIComponent(str).replace(/\+/g, ' '))
  );
};

export const serializeZoom = number => {
  return String(Math.round(number * 100) / 100);
};

export const serializeCenter = coord => {
  return `${coord[0].toFixed(3)},${coord[1].toFixed(3)}`;
};

export const deserializeCenter = str => {
  return str.split(',').map(Number);
};

export const serializeCompareSubjects = subjects =>
  subjects &&
  Object.keys(subjects)
    .filter(key => Boolean(subjects[key]))
    .map(key => {
      const subject = subjects[key];

      return subject.parent
        ? `${subject.type}::${subject.parent}::${subject.id}`
        : `${subject.type}::${subject.id}`;
    })
    .join(',');

export const deserializeCompareSubjects = str => {
  const subjectIds = str.split(',').slice(0, 2); // ensure it's 2 subjects
  const subjects = {};

  subjectIds.forEach((subjectId, index) => {
    const [type, ...rest] = subjectId.split('::');
    const id = rest.pop(); // id is always last
    const parent = rest.pop(); // parent Id

    subjects[index] = {
      type,
      id,
      parent,
    };
  });

  return subjects;
};

export const serializeHash = hash => {
  let hashStr = '';
  for (const key in hash) {
    hashStr += `/${key}/${hash[key]}`;
  }
  return hashStr;
};
